import axios from "axios";
import { AppConfig } from "../config/appConfig";

const baseURL = AppConfig.API_BASE_URL;

const apiClient = axios.create({
  baseURL: baseURL,
  withCredentials: true, // Importante para enviar cookies de Produce
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
/*
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    console.error(`[apiClient] Response Error: ${status} | URL: ${url} | Message: ${error.message}`);

    if (status === 401) {
      console.warn("[apiClient] 401 Unauthorized detected. Destroying session before redirect...");

      // Destruir token y usuario inmediatamente
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Limpiar cookies de Produce específicamente (Intento agresivo)
      const produceCookies = [
        ".AspNet.ApplicationCookieExtranet",
        ".AspNet.SharedCookie.Extranet"
      ];
      const domains = [
        window.location.hostname,
        `.${window.location.hostname}`,
        ".produce.gob.pe",
        "produce.gob.pe"
      ];
      const publicUrl = process.env.PUBLIC_URL === "." ? "" : (process.env.PUBLIC_URL || "");
      const paths = ["/", window.location.pathname, (publicUrl || "/")];

      produceCookies.forEach(name => {
        domains.forEach(domain => {
          paths.forEach(path => {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`;
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
          });
        });
      });

      // Limpiar todas las demás cookies accesibles
      document.cookie.split(";").forEach((c) => {
        const name = c.split("=")[0].trim();
        paths.forEach(path => {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
        });
      });

      // Notificar al resto de la app
      window.dispatchEvent(new Event("unauthorized"));

      if (!window.location.pathname.includes("/login")) {
        const publicUrl = process.env.PUBLIC_URL === "." ? "" : (process.env.PUBLIC_URL || "");
        window.location.href = publicUrl + "/login";
      } else {
      }
    }
    return Promise.reject(error);
  }
);*/
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;

    console.error(`[apiClient] Response Error: ${status} | URL: ${url} | Message: ${error.message}`);

    if (status === 401) {
      if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        console.warn("[apiClient] 401 omitido en entorno local. No se hace validación de login ni token.");
        return Promise.reject(error);
      }

      console.warn("[apiClient] 401 Unauthorized detected. Destroying session before redirect...");

      localStorage.removeItem("token");
      localStorage.removeItem("user");

      const produceCookies = [
        ".AspNet.ApplicationCookieExtranet",
        ".AspNet.SharedCookie.Extranet"
      ];

      const publicUrl = process.env.PUBLIC_URL === "." ? "" : (process.env.PUBLIC_URL || "");
      const paths = Array.from(new Set(["/", window.location.pathname, publicUrl || "/"]));

      const host = window.location.hostname;
      const domains = new Set([
        host,
        `.${host}`,
        ".produce.gob.pe",
        "produce.gob.pe"
      ]);

      // parent domain dinámico (por si cambias de subdominio)
      const parts = host.split(".");
      if (parts.length >= 3) domains.add("." + parts.slice(-3).join("."));

      const expireCookie = (name, domain, path) => {
        const base = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path};`;
        const withDomain = domain ? `${base} domain=${domain};` : base;

        document.cookie = withDomain;
        document.cookie = withDomain + " SameSite=Lax;";
        document.cookie = withDomain + " SameSite=None; Secure;";
      };

      // 1) borrar cookies específicas
      produceCookies.forEach((name) => {
        Array.from(domains).forEach((domain) => {
          paths.forEach((path) => {
            expireCookie(name, domain, path);
            expireCookie(name, "", path); // sin domain
          });
        });
      });

      // 2) borrar todas las cookies accesibles por JS
      document.cookie.split(";").forEach((c) => {
        const name = c.split("=")[0].trim();
        paths.forEach((path) => {
          expireCookie(name, "", path);
        });
      });

      window.dispatchEvent(new Event("unauthorized"));

      if (!window.location.pathname.includes("/login")) {

        // Si estamos en localhost, evitar la redirección
        if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        } else {
          window.location.href = publicUrl + "/login";
        }
      } else {
      }
    }

    return Promise.reject(error);
  }
);
export default apiClient;
